// Get tags here, tag count here
import type React from 'react';

import { Alert, Button, Text } from '@change/ds-core-ui';

import { Translate, TranslatePlural, useI18n } from '@change-corgi/core-react/i18n';

import { useAutoTaggedPetition } from './hooks/useAutoTaggedPetition';

type Props = {
	onDismiss?: () => void;
};

export const AutoTaggedPetition: React.FC<Props> = ({ onDismiss }) => {
	const { data, actions } = useAutoTaggedPetition({ onDismiss });
	const { translate } = useI18n();

	return (
		<Alert
			className="h-full w-full [&>div>div]:flex-row"
			variant="info"
			{...(onDismiss && {
				onDismissClick: actions.handleDismiss,
				dismissButtonAriaLabel: translate(
					'corgi.petition.starter_dashboard.notifications.auto_tagged_petition.dismiss_button_aria_label',
				),
			})}
			heading={
				<TranslatePlural
					value="corgi.petition.starter_dashboard.notifications.auto_tagged_petition.title"
					replacements={{ numTags: data.numTags }}
					count={data.numTags}
				/>
			}
			data-qa="auto-tagged-petition-message"
		>
			<Text as="p">
				<TranslatePlural
					value="corgi.petition.starter_dashboard.notifications.auto_tagged_petition.body"
					replacements={{ tags: data.tags.join(', ') }}
					count={data.numTags}
				/>
			</Text>
			<Button
				as="a"
				className="mt-4"
				data-testid="auto-tagged-petition-button"
				data-qa="auto-tagged-petition-button"
				variant="secondary-solid"
				size="x-small"
				href={data.anchorLink}
				onClick={actions.handleEditTags}
			>
				<Translate value="corgi.petition.starter_dashboard.notifications.auto_tagged_petition.primary_action_button" />
			</Button>
		</Alert>
	);
};
